import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import { headerHeight } from "../layout/header/header.styles";

const drawerWidth = "90%";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  toolbar: {
    height: headerHeight,
    px: ({ spacing }) => `${spacing(4)} !important`,
    justifyContent: "space-between",
  },

  close: {
    // marginRight: "-55px",
    // backgroundColor: "#222222",
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,

    "& .MuiDrawer-paper": {
      width: drawerWidth,
      boxSizing: "border-box",
      backgroundColor: "#222222",
    },
  },
};
